/**
 * Interface for cookie values received from the RumParams cookie
 */
export interface RumParams {
  rumAppMonitorId: string;
  rumAppMonitorName: string;
  region: string;
  stageSampleRate: number;
  telemetries: Array<string>;
  identityPoolId: string;
}

export enum RumBusinessEventAction {
  LOAD = 'load',
  SAVE = 'save',
}

export interface RumBusinessEventPayloadBase {
  action: RumBusinessEventAction;
  userAlias?: string;
  location?: string;
  component?: string;
  componentId?: string;
  service?: string;
  timezone?: string;
}

export interface RumBusinessEventPayloadOnLoad extends RumBusinessEventPayloadBase {
  action: RumBusinessEventAction.LOAD;
  location: string;
  value: number;
  duration: number;
}

export interface RumBusinessEventPayloadOnSave extends RumBusinessEventPayloadBase {
  action: RumBusinessEventAction.SAVE;
  location: string;
  duration: number;
  deckId: string;
  deckName: string;
  status?: 'success' | 'error';
  errorMessage?: string;
}

export type RumBusinessEventPayloadType = RumBusinessEventPayloadOnLoad | RumBusinessEventPayloadOnSave;
